import { $api } from '@/shared/api/axiosInstance';
import { getCookie } from '@/shared/lib/utils/getCookie';

export const sendLogLogin = async () => {
    const url = '/api/v1/log/LOGIN';

    const data = {
        from_url: getCookie('search_params'),
    };

    const res = await $api.post<ResponseType>(url, data);

    return res;
};
